import { ResponseLaborManagerCreate, RequestLaborManagerCreate } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { LaborManagerCreateActions } from '../actions';
import { LaborManagerCreateTypes } from '../../shared/enums';

export interface LaborManagerCreateState {
    response: ResponseLaborManagerCreate;
    request: RequestLaborManagerCreate;
    error: any;
}

export const LaborManagerCreateInitialState: LaborManagerCreateState = {
    response: null,
    request: null,
    error: null
};

const _laborManagerCreateReducer = createReducer(
    LaborManagerCreateInitialState,

    on(LaborManagerCreateActions.getLaborManagerCreate, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(LaborManagerCreateActions.getLaborManagerCreateSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(LaborManagerCreateActions.getLaborManagerCreateError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(LaborManagerCreateActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function laborManagerCreateReducer(state, action) {
    if (action.type === LaborManagerCreateTypes.LABOR_MANAGER_CREATE) {
        state = undefined;
    }
    return _laborManagerCreateReducer(state, action);
}
